<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div>
    <exchange-fee-override
      :initial-override-type="exchangeFeeOverrideType == null ? 'PERCENT' : exchangeFeeOverrideType"
      :initial-override-value="exchangeFeeOverrideValue"
      :validation-errors="$validator.messageBag.errors"
      :is-toggle-enabled="false"
      :can-be-removed="canBeRemoved"
      @cleared="clear"
      @value-changed="handleExchangeFeeUpdated" />
  </div>
</template>

<script type="text/babel">
  import { mapActions } from 'vuex';

  import ExchangeFeeOverride from '@/org-app/components/controls/ExchangeFeeOverride';

  export default {
    components: {
      ExchangeFeeOverride,
    },
    props: {
      entity: {
        type: Object,
      },
      canBeRemoved: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {};
    },
    computed: {
      isLineItem() {
        return this.entity.type === 'LineItem';
      },
      lineItem() {
        return this.isLineItem ? this.entity : undefined;
      },
      exchangeFeeOverrideType: {
        get() {
          return this.lineItem !== null && this.lineItem !== undefined ? this.lineItem.exchangeFeeOverrideType : null;
        },
        set(value) {
          this.updateLineItemExchangeFeeOverrideType({
            lineItem: this.lineItem,
            value: value !== undefined ? value : null,
          });
        },
      },
      exchangeFeeOverrideValue: {
        get() {
          return this.lineItem !== null && this.lineItem !== undefined ? this.lineItem.exchangeFeeOverrideValue : null;
        },
        set(value) {
          this.updateLineItemExchangeFeeOverrideValue({
            lineItem: this.lineItem,
            value: value !== undefined ? value : null,
          });
        },
      },
    },
    methods: {
      ...mapActions(['updateLineItemExchangeFeeOverrideType', 'updateLineItemExchangeFeeOverrideValue']),
      handleExchangeFeeUpdated(value) {
        this.exchangeFeeOverrideType = value.type;
        this.exchangeFeeOverrideValue = value.value;
        this.$emit('changed', value);
      },
      clear() {
        this.updateLineItemExchangeFeeOverrideType({ lineItem: this.lineItem, value: null });
        this.updateLineItemExchangeFeeOverrideValue({ lineItem: this.lineItem, value: null });
        this.$emit('cleared');
      },
    },
  };
</script>
